// The edge marks a route SSO return URL with this param when the builder's
// embedded browser started sign-in, so the API relays the handoff to the UI
// instead of navigating the popup to the edge.
export const ROUTE_SSO_POPUP_PARAM = "__3b_auth_popup";
export const ROUTE_SSO_BINDING_PARAM = "__3b_auth_binding";
export const ROUTE_SSO_PATH = "/auth/route-sso";
export const ROUTE_SSO_RELAY_PATH = `${ROUTE_SSO_PATH}/relay`;
export const ROUTE_SSO_RELAY_CHANNEL = "3b-route-sso";
